import * as React from "react";
import { Route, Routes, Link } from "react-router-dom";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import BottomNavigation from "@mui/material/BottomNavigation";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import InventoryIcon from "@mui/icons-material/Inventory";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

import Home from "./Home";

import ResponsiveAppBar from "../../components/ResponsiveAppBar";
import Orders from "./Orders";
import Inventory from "./Inventory";
import Profile from "./Profile";
import Login from "../Login";
import {
  HOME,
  INVENTORY,
  ORDERS,
  PROFILE,
  LOGIN,
  ORDER_DETAILS,
  NOTIFICATIONS,
} from "../../constants/paths";
import OrderDetails from "./Orders/OrderDetails";
import {
  HOME_PAGE,
  INVENTORY_PAGE,
  NOTIFICATIONS_PAGE,
  ORDERS_PAGE,
  PROFILE_PAGE
} from "../../constants/string";
import { Notifications } from "./Notifications";

const BottomNavigationAction = styled(MuiBottomNavigationAction)(`
  &.Mui-selected {
   
  }
`);

export default function FixedBottomNavigation() {
  const [value, setValue] = React.useState(0);
  const ref = React.useRef(null);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768); // Adjust the breakpoint as needed

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      {isMobile ? (
        <React.Fragment>
          <ResponsiveAppBar isMobile={isMobile}> </ResponsiveAppBar>
          <Routes>
            {/* <Route path={HOME} element={<Home />} /> */}

            <Route path={ORDERS} element={<Orders />} />
            <Route path={ORDER_DETAILS} element={<OrderDetails />} />

            <Route path={INVENTORY} element={<Inventory />} />
            <Route path={PROFILE} element={<Profile />} />
            <Route path={NOTIFICATIONS} element={<Notifications />} />
          </Routes>

          <Box sx={{ pb: 7 }} ref={ref}>
            <CssBaseline />

            <Paper
              sx={{ position: "fixed", bottom: 0, left: 0, right: 0 , zIndex: 2}}
              elevation={3}
            >
              <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
              >
                {/* <BottomNavigationAction
                  component={Link}
                  label={HOME_PAGE}
                  icon={<HomeIcon />}
                  to={HOME}
                /> */}
                <BottomNavigationAction
                  component={Link}
                  label={ORDERS_PAGE}
                  icon={<ShoppingBagIcon />}
                  to={ORDERS}
                />
                <BottomNavigationAction
                  component={Link}
                  label={INVENTORY_PAGE}
                  icon={<InventoryIcon />}
                  to={INVENTORY}
                />
                <BottomNavigationAction
                  component={Link}
                  label={PROFILE_PAGE}
                  icon={<PersonIcon />}
                  to={PROFILE}
                />
              </BottomNavigation>
            </Paper>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ResponsiveAppBar isMobile={isMobile}> </ResponsiveAppBar>

          <Routes>
            {/* <Route path={HOME} element={<Home />} /> */}
            <Route path={ORDERS} element={<Orders />} />
            <Route path={ORDER_DETAILS} element={<OrderDetails />} />
            <Route path={INVENTORY} element={<Inventory />} />
            <Route path={PROFILE} element={<Profile />} />
            <Route path={LOGIN} element={<Login />} />
          </Routes>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
